import {IMutableRulesetParams, MutableRuleset, template as tpl} from "./mutableRuleset";
import {IRule, IRuleset, TDataSourceType} from "../../../index";
import {_} from 'lodash';
import {global} from "../../../appContext";
import {MutableRule} from "./rule/MutableRule";
import {createErrorMessage, hasMultipleImportFormatTypes} from "../../../util/misc";
import {nsRuleset} from "../nsRuleset";
import {ERROR_MESSAGE, REQUEST_MESSAGE, UPDATING_MESSAGE} from "../../../constants/Language";
import {nsDataSource} from "../../../util/nsDataSource";

export let template: string = tpl;

export class viewModel extends MutableRuleset {

    protected override submitRequestMessage: string = UPDATING_MESSAGE;
    protected override submitSuccessMessage: string = `subject is updated|s:((ruleset))`;
    protected override submitErrorMessage: string = ERROR_MESSAGE;

    protected override readonly reqSubmit = global.getPromiseRequest("updateruleset");

    private _d!: IRuleset;

    constructor(params: IMutableRulesetParams) {
        super(params);
        this.isReady(false);
        this.init();
    }

    protected override init(): Promise<void> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return super.init()
            .then(() => {
                const req = this.__requestRouteData;
                if (!req) {
                    return;
                }
                return req
                    .request()
                    .then((data: any[]) => {
                        this._d = data[0] as IRuleset;
                        const org = global.login.selectedOrganization();
                        if (!this._d.authdatasources) {
                            if (hasMultipleImportFormatTypes() && org) {
                                this._d.authdatasources = nsDataSource.getImportFormatType(org.importformat);
                            }
                        }
                        if (this._d.authdatasources.includes(nsRuleset.AUTH_DATA_SOURCES_DELIMITER)) {
                            this._d.authdatasources = this._d.authdatasources.split(nsRuleset.AUTH_DATA_SOURCES_DELIMITER).join('');
                        }
                        // Just in case this is not sorted by the server...
                        this._d.rules = _.sortBy(this._d.rules, "order");
                        this.data.$original = this._d;
                        this.initialObjectTypeId = this._d.objecttype.id
                        this.initObjectTypes()
                        this.initData();
                    })
            })
            .then(() => {
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    protected override initData() {
        this.data.name(this._d.name);
        this.data.authdatasources(this._d.authdatasources as TDataSourceType);
        this.data.objectType(this.objectTypes.find(o => o.id == this._d.objecttype.id) ?? null);
        this.data.description(this._d.description);
        this.data.departmentexpression(this._d.departmentexpression)
        this.data.evaluatepositions(this._d.evaluatepositions)
        const rules = this._d.rules.map(r => this.staticToMutable(r));
        rules.forEach(r => r.initErrorTracking());
        this.data.rules(rules);
    }

    private staticToMutable(rule: IRule): MutableRule {
        return new MutableRule(this.availableData, rule);
    }

    protected override getSubmitData(): IRuleset {
        const data = _.defaultsDeep({
            authdatasources: this.data.authdatasources(),
            departmentexpression: this.data.departmentexpression(),
            description: this.data.description(),
            evaluatepositions: this.data.evaluatepositions(),
            name: this.data.name(),
            objecttype: this.data.objectType()!.type,
        }, this._d);
        delete data.rules;
        return data;
    }

    protected override onPreviewClick() {
        const rulesetNew = _.cloneDeep(this.getSubmitDataWithRules())
        const rulesetOld = _.cloneDeep(this.data.$original)
        rulesetNew.rules = _.sortBy(rulesetNew.rules, 'order')
        rulesetOld.rules = _.sortBy(rulesetOld.rules, 'order')
        const rulesChanged = !_.isEqual(rulesetOld.rules, rulesetNew.rules)
        const dataSourceChanged = rulesetOld.authdatasources != rulesetNew.authdatasources
        if (rulesChanged || dataSourceChanged) {
            nsRuleset.fnPreviewRulesetMutable(rulesetNew, rulesetOld)
        } else {
            nsRuleset.fnPreviewRuleset(rulesetNew)
        }
    }

}
